import { DefaultService } from '@/services/DefaultService';

export default class ImportacaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    importProProduto (blob) {
        return this._http.post(`${this._env}/promotor/produto/import-csv`, blob, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
    importProCliente (blob) {
        return this._http.post(`${this._env}/promotor/cliente/import-csv`, blob, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    importProLPS (blob) {
        return this._http.post(`${this._env}/promotor/lps/import-csv`, blob, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}